var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFluentVehicleCarProfile20Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14V16.5",
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5918,
    cy: 20,
    r: 3.25,
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30.1298V31.75C9 31.8881 9.11193 32 9.25 32H25.6712C25.8081 32 25.9196 31.8898 25.9212 31.7529L25.944 29.7988C25.9748 27.1576 23.8422 25 21.2009 25C21.1314 25 21.0613 25.0095 20.9941 25.0273C18.5331 25.6817 17.1809 25.6991 14.3301 25.0237C14.2648 25.0082 14.1969 25 14.1298 25C11.2967 25 9 27.2967 9 30.1298Z",
    stroke: "#383E42",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80671 14.9342C5.41172 9.2872 10.7912 4.75 17.5 4.75C24.1969 4.75 29.5693 9.27116 30.19 14.9042C28.7302 14.4023 27.5344 14.1493 26.3524 14.1764C25.0607 14.206 23.8519 14.5686 22.4004 15.1867C20.5958 14.4658 19.0863 14.1247 17.5355 14.1474C16.0067 14.1698 14.492 14.5456 12.6798 15.1738C11.4865 14.4651 10.3486 14.105 9.02418 14.1009C7.7962 14.0972 6.45037 14.4009 4.80671 14.9342Z",
    stroke: "#383E42",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentVehicleCarProfile20Regular);
export default __webpack_public_path__ + "static/media/fluent_vehicle-car-profile-20-regular.0ccac3c58b52143c9bdb69cf69b95baa.svg";
export { ForwardRef as ReactComponent };